<template>
  <div>
    <div
      v-if="!isMobile()"
      :class="{'display-flex' : $parent.videoComponents.filter( videoComponent => $parent.getActiveMedia(videoComponent.media).length < 1 ).length < 1}"
      style="overflow-x:auto; overflow-y:hidden">
      <b-row
        id="smallVideos"
        align-v="center"
        align-h="center"
        no-gutters>
        <div
          v-for="(videoComponent, index) in $parent.videoComponents"
          v-show="$parent.getActiveMedia(videoComponent.media).length < 1"
          :key="index"
          class="smallClient holder">
          <div
            :class="{ active: $parent.speaker_userId != '' && videoComponent.user.id == $parent.speaker_userId }"
            class="videoContainer rounded embed-responsive embed-responsive-16by9">
            <div class="camera-off"><span>{{ videoComponent.user.firstName }} {{ videoComponent.user.lastName }}</span></div>
            <div class="videoControl d-none d-md-block pushed">
              <span
                v-b-tooltip.hover.bottom
                v-if="videoComponent.user.isMuted"
                title="Mute"
                class="d-inline-block camera">
                <microphone-off-icon
                  :size="14"
                  class="muted top-control rounded-circle"/>
              </span>
            </div>
          </div>
        </div>
      </b-row>
    </div>
    <div
      :class="{'two': bigVideoStreams.length == 2, 'five-or-six': bigVideoStreams.length > 4 && bigVideoStreams.length < 12, 'maintainRatioTopBarMobile': isMobile(), 'maintainRatioTopBar': !isMobile() }">
      <b-row
        ref="bigVideos"
        :class="{ 'h-100': bigVideoStreams.length == 2 }"
        align-v="center"
        align-h="center"
        class="bigVideo"
        no-gutters
      >
        <div
          v-for="(stream, index) in bigVideoStreams"
          :key="index"
          :class="{ 'col-6 col-md-6': bigVideoStreams.length <= 4, 'col-12 col-md-12': bigVideoStreams.length <= 1, 'col-6 col-lg-4': bigVideoStreams.length > 4 && bigVideoStreams.length < 7, 'col-6 col-md-4': bigVideoStreams.length > 4 }"
          class="holder"
        >
          <div
            v-if="$parent.getActiveMedia(stream.media).length > 0"
            class="rounded embed-responsive embed-responsive-16by9"
          >
            <div
              v-show="!$parent.$parent.$refs.meetingControls.camera && stream.local"
              class="camera-off"><span>{{ $parent.$parent.userName }}</span></div>
            <video
              v-for="(media, indexVideo) in $parent.getActiveMedia(stream.media)"
              :ref="'bigVideo' + indexVideo"
              :key="indexVideo"
              :src-object.prop.camel="media.media"
              :class="{ active: $parent.speaker_userId != '' && stream.user.id == $parent.speaker_userId }"
              :style="$parent.computeVideoElementStyle(indexVideo)"
              style="cursor: pointer"
              autoplay="true"
              class="rounded embed-responsive-item"
              playsinline
              @loadeddata="(data) => { stream.loaded = true }"
              @click="$parent.moveToFirst(stream.media, media)"
              @pause="(e) => { e.target.play() }"
            />
            <div class="name-plate">{{ stream.user.firstName }} {{ stream.user.lastName }} </div>
          </div>
          <div
            v-if="$parent.getActiveMedia(stream.media).length > 0 && !stream.user.videoOff"
            :class="{'pushed': !$parent.$parent.$refs.meetingControls.mic && stream.source === 'camera' || (stream.user.isMuted && !stream.local), 'two-controls': !canDetach(index) || !canFullScreen(index) }"
            class="videoControl d-none d-md-block">
            <span
              v-b-tooltip.hover.bottom
              v-if="stream.source === 'camera' && stream.local"
              title="Mute"
              class="d-inline-block camera"
              @click="$parent.$parent.$refs.meetingControls.mic = !$parent.$parent.$refs.meetingControls.mic">
              <microphone-icon
                v-if="$parent.$parent.$refs.meetingControls.mic"
                id="selfMic"
                :size="24"
                class="top-control rounded-circle"/>
              <microphone-off-icon
                v-else
                id="selfMic-off"
                :size="24"
                class="muted top-control rounded-circle"/>
            </span>
            <span
              v-b-tooltip.hover.bottom
              v-show="stream.user.isMuted && !stream.local"
              title="muted"
              class="camera no-interaction">
              <microphone-off-icon
                :size="24"
                class="muted top-control rounded-circle"/>
            </span>
            <span
              v-b-tooltip.hover.bottom
              v-if="canDetach(index)"
              title="Popout"
              class="d-inline-block popout"
              @click="detach(index)"
            >
              <pop-out-icon
                id="selfPop"
                :size="24"
                class="top-control rounded-circle"/>
            </span>
            <span
              v-b-tooltip.hover.bottom
              v-if="canFullScreen(index)"
              title="Fullscreen"
              class="d-inline-block fullscreen"
              @click="makeFullScreen(index)"
            >
              <fullscreen-icon
                :size="24"
                class="top-control rounded-circle"/>
            </span>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>
<script>
import { isMobile } from "../../functions/browserDetails"
import { ref, watch, computed } from "@vue/composition-api"
import MicrophoneIcon from "icons/Microphone"
import MicrophoneOffIcon from "icons/MicrophoneOff"
import PopoutIcon from "../../icons/Popout";
import FullscreenIcon from "icons/Fullscreen"
export default {
  name: 'AllVideos',
  components : {
    'microphone-icon': MicrophoneIcon,
    'microphone-off-icon': MicrophoneOffIcon,
    'pop-out-icon': PopoutIcon,
    'fullscreen-icon': FullscreenIcon,
  },
  setup(props, context) {
    const bigVideoStreams = computed(() => {
      let bigVideoStreams = []
      context.parent.videoComponents.forEach (videoComponent => {
        if (context.parent.getActiveMedia(videoComponent.media).length > 0)
          bigVideoStreams.push(videoComponent)
      })
      return bigVideoStreams
    })

    function canDetach (index) {
      return !isMobile() && (document.pictureInPictureEnabled)
    }

    function detach (index) {
      context.refs.bigVideo0[index].requestPictureInPicture()
    }

    function canFullScreen (index) {
      return !isMobile() && (document.fullscreenEnabled)
    }

    function makeFullScreen (index) {
      context.refs.bigVideo0[index].requestFullscreen()
    }

    return {
      bigVideoStreams,
      isMobile,
      canDetach,
      detach,
      canFullScreen,
      makeFullScreen
    }
  }
}
</script>
<style scoped>
.camera-off{
  position: absolute;
  top:0;
  left: 0;
  height: 100%;
  z-index: 2;
  font-weight: 600;
  font-size: 36px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.smallClient .camera-off{
  font-size: 16px;
}

.display-flex {
  display: flex;
}

.maintainRatioTopBar{
  max-height: calc(100vh - 228px);
  width: calc((100vh - 228px) * (16/9));
  max-width: 100%;
  margin: 0 auto;
}
.maintainRatioTopBarMobile{
  max-height: calc(100vh - 112px);
  width: calc((100vh - 112px ) * (16/9));
  max-width: 100%;
  margin: 0 auto;
}
#smallVideos{
  display: inline-flex;
  flex-wrap: nowrap;
  min-width: 100%;
  max-height: 112px;
  position: relative;
  z-index: 200;
  padding: 0 7px;
}

  .muted { background-color:#ffffff; color:#e72113; display: inline-flex; opacity: 1!important;}
  .muted:hover{ background-color: #ffffff}

.bigVideo{
  position: relative;
  z-index: 11;
  padding: 6px;
}
.bigVideo .holder {
  padding: 6px;
}

@media (min-width: 768px) {
  .mobileHeight {
    padding: 6px;
    height: calc(100vh - 92px);
  }
  .two, .five-or-six {
    width: calc(100% + 12px);
    margin: 0 -6px;
    max-width: none;
  }
  .five-or-six {
    margin: auto;
    max-width: calc(100vh * 16 / 9);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoArea/AllVideos.vue